import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
// import 'swiper/dist/css/swiper.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
import App from './App.vue';
import router from './router';
import Module from './providers/module';
import animated from 'animate.css';
import SwiperCore, {Mousewheel, Pagination, Autoplay}  from 'swiper';
SwiperCore.use([Mousewheel, Pagination, Autoplay]);
Vue.use(animated);
Vue.use(VueAwesomeSwiper, /* { default global options } */ );
Vue.use(ElementUI);
Vue.use(VueVideoPlayer,
  /* {
  options: global default options,
  events: global videojs events
} */
);
Vue.use(Module);

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')